export default "__VITE_ASSET__DtJxB_nX__"